/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import DisplayCheckTableComponent from './component/DisplayCheckTableComponent';
import {
  getgeneralsystemparameterDetails,
  getReferenceList,
} from './store/action';
import { handleScrollToEvent } from '../../../SharedModules/CommonUtilities/commonUtilities';

const DisplayCheck = () => {
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state.sharedState.displayCheck.loading
  );
  const errorPopupMessage = useSelector(
    (state) => state.sharedState.displayCheck.errorPopupMessage
  );
  const successMessage = useSelector(
    (state) => state.sharedState.displayCheck.successMessage
  );

  const checkData = useSelector(
    (state) => state.sharedState.displayCheck.checkData
  );
  const referenceData = useSelector(
    (state) => state.sharedState.displayCheck.referenceData
  );

  const systemParameter = useSelector(
    (state) => state.sharedState.displayCheck.systemParameter
  );

  const [fullScreen, setFullScreen] = useState(false);

  useEffect(() => {
    dispatch(getgeneralsystemparameterDetails());
    handleScrollToEvent();
    dispatch(
      getReferenceList({
        codeDomainList: [
          'DISPUTE_RESOLUTION_CD',
          'CHECK_PAYEE_CD',
          'COLLECTION_MEDIUM_CD',
          'PAYMENT_MEDIA_TYPE_CD',
          'INV_REC_FORMAT_CD',
          'LAST_UPDATE_USER_ID',
        ],
      })
    );
  }, []);

  return (
    <div className="tabs-container tBillPanel custom-check">
      {loading && <Spinner load={loading} />}
      {!fullScreen && (
        <CustomSeparator parent1="Display" parent2="Checks List" />
      )}
      {successMessage && (
        <DisplaySuccessMessages
          successMessages={
            typeof successMessage === 'string'
              ? [successMessage]
              : successMessage
          }
        />
      )}
      {errorPopupMessage && (
        <DisplayErrorMessages
          errorMessages={
            typeof errorPopupMessage === 'string'
              ? [errorPopupMessage]
              : errorPopupMessage
          }
        />
      )}
      <div className="row my-5">
        <DisplayCheckTableComponent
          tableData={checkData}
          referenceData={referenceData}
          systemParameter={systemParameter}
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
        />
      </div>
    </div>
  );
};

export default DisplayCheck;
